import { IAuthFuncPermissaoResponse } from 'src/app/services/AuthService/auth.model';
import {
  IOpcaoAcaoResponse,
  IOpcaoAcao,
  IOpcaoTela,
  IOpcaoTelaResponse
} from './permissionScreen.types';

import data from '../../../../appsettings.json';

export function validarPermissao(tela: IOpcaoTela, acao: IOpcaoAcao): boolean {
  const permissaoList = JSON.parse(localStorage.getItem('permissao') ?? '') as
    | IAuthFuncPermissaoResponse[]
    | null;

  const telaConvertida = converterTelaResponse(tela);
  const acaoConvertida = converterAcaoResponse(acao);
  let permissao;

  if (permissaoList && permissaoList?.length > 0) {
    if (telaConvertida)
      permissao = permissaoList.find(x => x.TX_TIPO_PERM == telaConvertida);

    if (acaoConvertida && permissao)
      return (
        permissao[`${acaoConvertida}`] ??
        Boolean(data.permissionScreen.defaultPermission ?? false)
      );
  }

  return Boolean(data.permissionScreen.defaultPermission ?? false);
}

function converterAcaoResponse(acao: IOpcaoAcao): IOpcaoAcaoResponse | null {
  const acaoMap: Record<IOpcaoAcao, IOpcaoAcaoResponse> = {
    incluir: 'FL_INCL',
    consultar: 'FL_CNST',
    editar: 'FL_EDIT',
    exportar: 'FL_EXPT',
    suspender: 'FL_SPND',
    deletar: 'FL_DELT',
    imprimir: 'FL_IMPR',
    anexar: 'FL_ANEX',
    faturarCliente: 'FL_FTRT_CLNT'
  };

  return acaoMap[acao] ?? null;
}

function converterTelaResponse(tela: IOpcaoTela): IOpcaoTelaResponse | null {
  const telaMap: Record<IOpcaoTela, IOpcaoTelaResponse> = {
    cadastrarFuncionario: 'Cadastro de Funcionários',
    listaFuncionario: 'Lista de Funcionários',
    cadastrarPerfil: 'Cadastro de Perfis',
    listaPerfil: 'Lista de Perfis',
    permissaoAcesso: 'Permissões de Acessos',
    listaAgendamento: 'Listagem de Agendamentos',
    parametrizacaoPatio: 'Gerenciamento de Pátio',
    parametrizacaoServico: 'Serviços',
    parametrizacaoPreco: 'Tabela de Preços',
    parametrizacaoBlackList: 'BlackList',
    listaEmpresa: 'Listagem de Empresa',
    transferenciaEmpresaFrota: 'Transferência de Frota entre Empresas',
    listaBlackList: 'Listagem de BlackList',
    cadastrarGateEntrada: 'Cadastrar Entrada',
    listaGateEntrada: 'Lista de Entradas',
    cadastrarServico: 'Entrada de Serviços',
    listaServico: 'Lista de Serviços',
    cadastrarLaudoHigienizacao: 'Laudo de Higinização',
    listaLaudoHigienizacao: 'Lista de Laudo Higinização',
    cadastrarEntradaTampa: 'Entrada Tampa/Grade/Palete',
    cadastrarSaidaTampa: 'Saída Tampa/Grade/Palete',
    listaTampa: 'Listagem Tampa/Grade/Palete',
    cadastrarDesengate: 'Cadastrar Desengate',
    listaDesengate: 'Lista de Desengate',
    cadastrarEngate: 'Cadastrar Engate',
    listaEngate: 'Lista de Engate',
    cadastrarGateSaida: 'Cadastrar Saída',
    listaGateSaida: 'Lista de Saídas',
    cadastrarSangria: 'Sangria',
    cadastrarSuprimento: 'Suprimento',
    cadastrarAberturaCaixa: 'Abertura/Fechamento de Caixa',
    parametrizacaoAcessos: 'Parametrização de Acessos',
    listaLogs: `LOGs`,
    higienizacaoAgendada: 'Agendamento de Higienização',
    listaMotoristasExterno: 'Listagem de Motoristas Externo',
    caixaHigienizacao: 'Caixa Higienização',
    caixaPatio: 'Caixa Pátio',
    parametrizacaoFila: 'Parametrização de Fila',
    parametrizacaoTolerancia: 'Tolerância de Agendamento',
    listaProduto: 'Estoque',
    cadastrarProduto: 'Estoque',
    listaEstoque: 'Estoque',
    cadastrarEntradaEstoque: 'Estoque',
    cadastrarSaidaEstoque: 'Estoque',
    listaInventario: 'Estoque',
    listaMovimentacoesEstoque: 'Estoque',
    cadastrarAjusteEstoque: 'Estoque',
    relatorioVendasEstoque: 'Relatório Vendas Estoque',
    relatorioMovimentacoesEstoque: 'Relatório Movimentações Estoque',
    relatorioPosicaoEstoque: 'Relatório Posição Estoque',
    caixaEstoque: 'Caixa Estoque',
    graficoServicosIndicadorLimpezas: 'Gráfico: Limpezas no período',
    graficoServicosIndicadorAgendamentos: 'Gráfico: Agendamentos de limpeza',
    graficoServicosIndicadorMediaCaminhoes: 'Gráfico: Média de caminhões/dia',
    graficoServicosIndicadorTerminaisAtivos: 'Gráfico: Terminais ativos',
    graficoServicosIndicadorReceita: 'Gráfico: Receita no período',
    graficoLimpezasPorMes: 'Gráfico: Limpezas por mês',
    graficoLimpezasPorTerminal: 'Gráfico: Limpezas por terminal',
    graficoLimpezasPorTransportadora: 'Gráfico: Limpezas por transportadora',
    graficoLimpezasAgendadas: 'Gráfico: Limpezas agendadas',
    graficoMediaMensalServico: 'Gráfico: Média mensal por serviço',
    graficoVendasQtdTipoServico: 'Gráfico: Qtd vendas por tipo de serviço',
    graficoVendasValorTipoServico: 'Gráfico: Valor vendas por tipo de serviço',
    graficoDistribuicaoFormaPagamento: 'Gráfico: Distribuição forma de pagamento',
    graficoValoresFormaPagamento: 'Gráfico: Valores forma de pagamento',
    graficoPatioTotalVeiculos: 'Gráfico: Total de veículos',
    graficoPatioAgendadoTerminais: 'Gráfico: Agendado por terminais',
    graficoPatioTotalNoPatio: 'Gráfico: Total no pátio',
    graficoPatioTempoPermanencia: 'Gráfico: Tempo de permanência',
    graficoPatioDiarioTotal: 'Gráfico: Diário total',
    graficoPatioAgendamentosD: 'Gráfico: Agendamentos D',
    graficoPatioAgendamentosD1: 'Gráfico: Agendamentos D+1',
    graficoPatioAgendamentosD2: 'Gráfico: Agendamentos D+2',
    graficoPatioEstacionamento: 'Gráfico: Quantidade de estacionamento',
    graficoPatioTurnos: 'Gráfico: Turnos e veículos',
    graficoEstoqueIndicadores: 'Gráfico: Indicadores Estoque',
    graficoEstoqueUltimasMovimentacoes: 'Gráfico: Últimas movimentações Estoque',
    graficoEstoqueUltimasVendas: 'Gráfico: Últimas vendas Estoque',
    relatorioVeiculos: 'Relatório Veículos',
    historicoVeiculo: 'Histórico por Veículo',
    laudosEditados: 'Laudos Editados',
    financeiroMlServicos: 'Dashboard Serviços',
    financeiroPatio: 'Dashboard Pátio',
    dashboardFinanceiro: 'Dashboard Financeiro',
    vendasPorProduto: 'Vendas por Produto',
    laudosExcluidosCancelados: 'Laudos Excluídos e Cancelados',
    relatorioTerminal: 'Relatório por Terminal',
    relatorioTerminalPdf: 'Terminal (PDF)',
    relatorioCarregamentoQuantitativo: 'Carregamento - Quantitativo (PDF)',
    relatorioCarregamentoDetalhado: 'Carregamento - Detalhado (PDF)',
    relatorioClienteQuantitativo: 'Cliente - Quantitativo (PDF)',
    relatorioClienteDetalhado: 'Cliente - Detalhado (PDF)',
    relatorioMensalLaudos: 'Mensal (PDF)',
    relatorioQuantidadeClienteLaudos: 'Quantidade por Cliente (PDF)',
    relatorioPlacasCaixa: 'Placas - Caixa',
    relatorioClientesCaixa: 'Vendas Estoque'
  };

  return telaMap[tela] ?? null;
}
